import React from 'react';

export type ImageDimensions = { width: number; height: number; loaded: boolean };

export const useImageDimensions = (url: string | null | undefined): ImageDimensions => {
  const [dimensions, setDimensions] = React.useState<ImageDimensions>({
    width: 0,
    height: 0,
    loaded: false,
  });

  React.useEffect(() => {
    if (!url) return;

    const img = new Image();
    img.onload = (): void => {
      // We divide by 2 in order to take into account devices with DPI 2 like Macs
      setDimensions({ height: img.height / 2, width: img.width / 2, loaded: true });
    };

    img.src = url;
  }, [url]);

  return dimensions;
};
